<template>
    <div class="content">
        <div class="divA">
            <img class="divA1" src="../assets/images2/1.png" alt="" />
            <div class="divA2" style="cursor: pointer;" @click="$router.replace('/login')">
                <div class="divA21">log in</div>
                <img class="divA22" src="../assets/images2/3.png" alt="" />
            </div>
        </div>
        <div class="divB">
            <div class="formV">
                <div class="formVV">
                    <div class="name">Forgot password</div>
                    <div class="t">
                        <span class="t1">Already have an account?</span>
                        <span class="t2" @click="goRegister" style="cursor: pointer;">Register an account</span>
                    </div>
                    <div class="valueA">
                        <el-input v-model="email" placeholder="">
                            <template slot="prefix">
                                <span>Email</span>
                                <img class="Require" src="../assets/images2/5.png" alt="" />
                            </template>
                        </el-input>
                    </div>
                    <!-- <div class="valueB">
                        <el-input v-model="Password" show-password placeholder="">
                            <template slot="prefix">
                                <span>Password</span>
                                <img class="Require" src="../assets/images2/5.png" alt="" />
                            </template>
                        </el-input>
                    </div> -->
                    <div class="Forgot">Forgot your password?</div>
                    <div class="checkboxV">
                        <!-- 7 false   -->
                        <!-- <el-checkbox v-model="checked">i agree to User Agreement and Privacy Policy</el-checkbox> -->
                        <img class="checkImg"
                            :src="checked ? require('../assets/images2/6.png') : require('../assets/images2/7.png')" alt=""
                            @click="goChange" />
                        <div class="checkName">I agree to <span class="checkName1" @click="goText(0)">User Agreement</span>
                            and <span class="checkName1" @click="goText(1)">Privacy
                                Policy</span></div>
                    </div>

                    <el-button class="btn" @click="Reset" v-preventReClick="3000">Reset password</el-button>
                    <!-- <div>Reset password</div> -->
                </div>
            </div>
        </div>
        <div class="divC">
            <img class="divC1" src="../assets/images2/4.png" alt="" />
            <div class="divC2">All Rights Reserved@2023 orjoy</div>
        </div>
    </div>
</template>

<script>
export default {
    mixins: [],
    components: {
    },
    data() {
        return {
            checked: false,
            email: '',
            Password: ''
        };
    },
    created() {

        //取
        // this.phone = JSON.parse(localStorage.getItem("account")) || '';
        // this.password = JSON.parse(localStorage.getItem("password")) || '';
    },
    mounted() {

    },
    methods: {
        // 0用户协议、1隐私协议
        goText(e) {
            this.$router.push({
                path: "/Text",
                query: {
                    type: e
                }
            })
        },
        async Reset() {
            let reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
            if (!reg.test(this.email)) { //当邮箱不符合校验规则时
                this.$message({
                    message: 'The mailbox format is incorrect',
                    type: 'warning'
                });
                return
            }
            if (!this.checked) {
                this.$message({
                    message: 'Please check the User Agreement',
                    type: 'warning'
                });
                return
            }

            try {
                // captchaEmail?email=947008486@qq.com
                const res = await this.$post('sendPwdEmail', {
                    email: this.email, //邮箱
                    url: ''
                    // url: 'http://localhost:8080/#/ResetLogin'
                })
                this.$message({
                    message: res.msg,
                    type: 'success'
                });
                // this.$router.push('/ResetLogin')
                console.warn(res, "res")
            } catch (error) {
            }

            // 821939079@qq.com


        },
        // this.$message.error('下载fail，请稍后重试');
        goRegister() {
            this.$router.push('/CreateLogin')
        },
        goChange() {
            this.checked = !this.checked;
        },
        async keyDown() {
            if (!this.checked) {
                this.$message({
                    message: '请勾选用户协议',
                    type: 'warning'
                });
                return
            }
            await getLoginApi({
                // account: '13001903775',
                // password: '123123'
                account: this.phone,
                password: this.password
            }).then((res) => {
                if (res.code == 1) {
                    localStorage.setItem("avatar", res.data.userinfo.avatar);
                    localStorage.setItem("username", res.data.userinfo.username);
                    localStorage.setItem("account", this.phone);
                    localStorage.setItem("password", this.password);
                    localStorage.setItem("allNews", JSON.stringify(res.data));   //所有信息
                    localStorage.setItem('TIANYUE_TOKEN', res.data.userinfo.token)
                    this.$store.commit('updateUserInfo', res.data.userinfo)
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                    setTimeout(() => {
                        this.$router.push({
                            path: "/home",
                        })
                    }, 1000);
                }

                if (res.code == 0) {
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    });
                }
            }).catch((err) => {
                console.log(err);
            })
        },
        async goPPP(e) {
            await this.$router.push({
                path: "/policy",
                query: { type: e }
            })
        },
        async LoginGo() {
            if (!this.checked) {
                this.$message({
                    message: '请勾选用户协议',
                    type: 'warning'
                });
                return
            }
            await getLoginApi({
                // account: '13001903775',
                // password: '123123'
                account: this.phone,
                password: this.password
            }).then((res) => {
                if (res.code == 1) {
                    localStorage.setItem("avatar", res.data.userinfo.avatar);
                    localStorage.setItem("username", res.data.userinfo.username);
                    localStorage.setItem("account", this.phone);
                    localStorage.setItem("password", this.password);
                    localStorage.setItem("allNews", JSON.stringify(res.data));   //所有信息
                    localStorage.setItem('TIANYUE_TOKEN', res.data.userinfo.token)
                    this.$store.commit('updateUserInfo', res.data.userinfo)
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                    setTimeout(() => {
                        this.$router.push({
                            path: "/home",
                        })
                    }, 1000);
                }

                if (res.code == 0) {
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    });
                }
            }).catch((err) => {
                console.log(err);
            })
        },
        // 忘记密码
        goForget() {
            this.$router.push({
                path: "/forgetLogin"
            })
        }
    },
};
</script>

<style lang="scss" scoped>
.content {
    width: 100%;
    height: 100%;

    .divA {
        margin-top: 80px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .divA1 {
            margin-left: 110px;
            width: 127px;
            height: 35px;
        }

        .divA2 {
            margin-right: 91px;
            display: flex;
            flex-direction: column;
            align-items: center;

            .divA21 {
                font-size: 24px;
                font-family: Poppins, Poppins-700;
                font-weight: 700;
                color: #12181d;
            }

            .divA22 {
                margin-top: 8px;
                width: 108px;
                height: 20px;
            }
        }
    }

    .divB {
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: url('../assets/images2/2.png');
        background-size: 100% 100%;
        background-position: center center;
        width: 100%;
        height: 627px;

        .formV {
            width: 580px;
            // height: 482px;
            background: #f7f8fa;
            border-radius: 16px;

            .formVV {
                margin: 32px 32px;
                display: flex;
                flex-direction: column;
                align-items: center;

                .btn {
                    margin-top: 24px;
                    font-size: 14px;
                    font-family: Inter, Inter-400;
                    font-weight: 400;
                    color: #ffffff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 57px;
                    background: #f624d5 linear-gradient(90deg, #f624d5, #3437f7 100%);
                    border-radius: 8px;
                }

                .name {
                    // margin-top: 24px;
                    font-size: 56px;
                    font-family: Poppins, Poppins-700;
                    font-weight: 700;
                    color: #12181d;
                }

                .t {
                    margin-top: 15px;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .t1 {
                        font-size: 16px;
                        font-family: PingFang SC, PingFang SC-400;
                        font-weight: 400;
                        color: #12181d;
                    }

                    .t2 {
                        margin-left: 8px;
                        font-size: 16px;
                        font-family: PingFang SC, PingFang SC-400;
                        font-weight: 400;
                        color: #fa14d5;
                    }
                }

                .valueA {
                    width: 100%;
                    margin-top: 32px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 53px;
                    background: #ffffff;
                    border-radius: 8px;
                }

                .valueB {
                    width: 100%;
                    margin-top: 24px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 53px;
                    background: #ffffff;
                    border-radius: 8px;
                }

                .Forgot {
                    margin-top: 16px;
                    font-size: 14px;
                    font-family: Poppins, Poppins-400;
                    font-weight: 400;
                    color: #12181d;
                }

                .checkboxV {
                    margin-top: 32px;
                    width: 100%;
                    display: flex;
                    align-items: center;

                    .checkImg {
                        width: 12px;
                        height: 12px;
                    }

                    .checkName {
                        margin-left: 5px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 12px;
                        font-family: Poppins, Poppins-400;
                        font-weight: 400;
                        color: #3f5566;

                        .checkName1 {
                            margin: 0 5px;
                            font-size: 12px;
                            font-family: Poppins, Poppins-400;
                            font-weight: 400;
                            color: #FA14D5;
                        }
                    }
                }
            }
        }
    }

    .divC {
        margin-bottom: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .divC1 {
            margin-left: 110px;
            width: 28px;
            height: 4px;
        }

        .divC2 {
            margin-right: 91px;
            font-size: 16px;
            font-family: Inter, Inter-400;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.60);
        }
    }
}

.Require {
    margin-left: 5px;
    width: 5px;
    height: 4px;
}

::v-deep .el-input__inner {
    border: none !important;
}

::v-deep .el-input__prefix {
    margin-left: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
}

::v-deep.el-input--prefix .el-input__inner {
    padding-left: 100px !important;
}
</style>
